import React from 'react';
import styles from './charts.module.css';

/**
 * Horizontal bars, one per item, labelled with their value.
 * items: [{ key, label, value, hint? }]
 */
const BarChart = ({ items, color = 'var(--series-1)', emptyText = 'No data.', formatValue = (value) => value.toLocaleString() }) => {
  if (!items?.length || items.every((item) => !item.value)) {
    return <p className={styles.empty}>{emptyText}</p>;
  }
  const max = Math.max(...items.map((item) => item.value), 1);
  return (
    <ul className={styles.bars}>
      {items.map((item) => (
        <li key={item.key} className={styles.barRow} title={`${item.label}: ${formatValue(item.value)}${item.hint ? ` (${item.hint})` : ''}`}>
          <span className={styles.barLabel}>{item.label}</span>
          <span className={styles.barTrack}>
            <span
              className={styles.barFill}
              style={{ width: `${(item.value / max) * 100}%`, background: item.color || color }}
            />
          </span>
          <span className={styles.barValue}>{formatValue(item.value)}</span>
        </li>
      ))}
    </ul>
  );
};

export default BarChart;
